<footer class="footer">
    <div class="grid-container">
        <div class="footer-item">
            <img src="assets/version2/logo_dark_word.svg" alt="Logo" width="100"><br>
            <span><img src="assets/version2/linkedin.JPG" alt="Logo"></span>
            <span><img src="assets/version2/facebook.JPG" alt="Logo" style="padding-left: 5px;">
                <span><img src="assets/version2/twitter.JPG" alt="Logo" style="padding-left: 5px;"></span>
            </span>
        </div>
        <div class="footer-item">
            <ul>
                <li><a href="https://iylon.com/about/">About Us</a></li>
                <li><a href="https://iylon.com/team/">Our Team</a></li>
                <li><a href="https://iylon.com/how-it-works/">How It Works</a></li>
                <li><a href="https://iylon.com/resources/">Resources</a></li>
            </ul>
        </div>
        <div class="footer-item">
            <ul>
                <li><a href="https://iylon.com/faq/">FAQ</a></li>
                <li><a href="https://iylon.com/advisors/">Advisors</a></li>
                <li><a href="https://iylon.com/affiliates/">Affiliates</a></li>
                <li><a href="https://iylon.com/contact/">Contact Us</a></li>
            </ul>
        </div>
        <div class="footer-item">
            <ul>
                <li><a href="https://app.iylon.com/">Login</a></li>
                <li><a href="https://app.iylon.com/#/home/join-meeting">Join Meeting</a></li>
                <li><a href="https://iylon.com/terms-of-service/">Terms Of Service</a></li>
                <li><a href="https://iylon.com/privacy-policy/">Privacy Policy</a></li>
            </ul>
        </div>
        <!-- Add more rows as needed -->
    </div>
</footer>
<footer class="footer-1">
    <div class="footer-1-content">
      <p>© 2024 Iylon Precision Oncology | All Rights Reserved.</p>
    </div>
  </footer>
  